import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";

interface Props {
    gradient?: boolean;
    children: ReactNode;
}

const hugeTitleClass = css({
    fontWeight: 500,
    fontFamily: "Inter, sans-serif",
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "-2%",
    textAlign: "left",
    background: "neutral.100",
    backgroundClip: 'text',
    color: 'transparent'
})

const gradientClass = css({
    background: "linear-gradient(90deg, #BA9BFF 0%, #0E4DEC 71.21%)"
})

const HugeTitle: FC<Props> = ({gradient, children}) => {
    return <h1 className={cx(hugeTitleClass, gradient && gradientClass)}>{children}</h1>
}

export default HugeTitle